import React, { useState, useEffect } from "react";
import './ForgotPassword.css';
import '../Login/Login.css';
import { Globals } from "../../global/Globals";
import Button from "../../components/Button/Button";
import Footer from "../../components/Footer/Footer";
import { validatePassword } from '../../util/util';
import { getRecordsFromResetLink, resetAccount } from '../../services/ForgotPasswordAPI';
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import PopUp from "../../components/PopUp/PopUp";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const { activationToken } = useParams();
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [reEnteredPassword, setReEnteredPassword] = useState('');
    const [isPasswordEmpty, setPasswordEmpty] = useState('');
    const [isReEnteredPasswordEmpty, setReEnteredPasswordEmpty] = useState('');
    const [isPasswordInValid, setPasswordInValid] = useState(false);
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [isReEnteredPasswordInValid, setReEnteredPasswordInValid] = useState(false);
    const [isReEnteredPasswordVisible, setReEnteredPasswordVisible] = useState(false);
    const [isPasswordNotMatched, setIsPasswordNotMatched] = useState(false);
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [isResetSuccess, setIsResetSuccess] = useState(false);
    const [isResetFailure, setIsResetFailure] = useState(false);
    const [isPasswordFieldMisMatch, setPasswordFieldMisMatch] = useState(false);
    const handlePassword = (e) => {
        setPasswordEmpty(false);
        setPasswordInValid(false);
        setPassword(e.target.value);
        setIsPasswordNotMatched(false);
        setPasswordFieldMisMatch(false);
    }

    useEffect(() => {
        try {
            getRecordsFromResetLink((activationToken).replace(/:/, "")).then((resp) => {
                const data = resp?.data?.content?.message;
                if (data && data.toLowerCase().includes("error")) {
                    setIsDataAvailable(false);
                } else {
                    setEmail(data);
                    setIsDataAvailable(true);
                }
            })
                .catch((error) => {
                    setIsDataAvailable(false);
                    console.error("Error in getting records from Reset Password link : ", error);
                })
        }
        catch (error) {
            setIsDataAvailable(false);
            console.error("Error in getting records from Reset Password link : ", error);
        }
    }, [!isDataAvailable, activationToken])

    const handleReEneteredPassword = (e) => {
        setReEnteredPasswordEmpty(false);
        setReEnteredPasswordInValid(false);
        setIsPasswordNotMatched(false);
        setReEnteredPassword(e.target.value);
    }
    const tooglePasswordView = (id, mode) => {
        const passwordInput = document.getElementById(id);
        const passwordType = passwordInput.getAttribute('type');
        if (passwordType === 'password') {
            passwordInput.setAttribute('type', 'text');
            mode === "password" ? setPasswordVisible(true) : setReEnteredPasswordVisible(true);
        }
        else {
            passwordInput.setAttribute('type', 'password');
            mode === 'password' ? setPasswordVisible(false) : setReEnteredPasswordVisible(false);
        }
    }

    const checkForPassword = (fieldName) => {
        if (fieldName === 'password') {
            setPasswordEmpty(false);
            setPasswordInValid(false);
            setPasswordFieldMisMatch(false);
            if (password.length > 0) {
                const isValid = validatePassword(password);
                isValid ? setPasswordInValid(false) : setPasswordInValid(true);
                if ((password.length > 0 && reEnteredPassword.length > 0) && (password !== reEnteredPassword)) {
                    setPasswordFieldMisMatch(true);
                    setIsPasswordNotMatched(false);
                }
            }
            else {
                setPasswordEmpty(true);
            }
        }
        else {
            setReEnteredPasswordInValid(false);
            setReEnteredPasswordEmpty(false);
            setIsPasswordNotMatched(false);
            if (reEnteredPassword.length > 0) {
                if (password !== reEnteredPassword) {
                    setIsPasswordNotMatched(true);
                    setPasswordFieldMisMatch(false);
                }
                else {
                    setIsPasswordNotMatched(false);
                    const isValid = validatePassword(reEnteredPassword);
                    isValid ? setReEnteredPasswordInValid(false) : setReEnteredPasswordInValid(true);
                }
            }
            else {
                setReEnteredPasswordEmpty(true);
            }
        }
    }
    const submitDetails = () => {
        password === reEnteredPassword ? setIsPasswordNotMatched(false) : setIsPasswordNotMatched(true);
        if (!isPasswordFieldMisMatch && !isPasswordNotMatched && !isPasswordEmpty && !isPasswordInValid && !isReEnteredPasswordEmpty && !isReEnteredPasswordInValid) {
            resetAccount(email, password.toString(), (activationToken).replace(/:/, "")).then((response, error) => {
                if (response.data.status  === 'OK') {
                    setIsResetSuccess(true);
                }
                else {
                    console.error("Error in Reset API ===> ", error);
                    setIsResetFailure(true);
                }

            }).catch((error) => {
                console.error("Error in Reset API ===> ", error);
                setIsResetFailure(true);
            })
        }
    }

    const navigateToLogin = () => {
        navigate(Globals.NAVPATH.HOME)
    }
    return (
        <>
            {!isDataAvailable && <Loader height={50} width={50} component={"Myproposals"} />}
            <div id="reset-page-layout" className="reset-page-layout">
                <div id="reset-page-container" className="reset-page-container">
                    <div id="reset-page-content-container" className="reset-page-content-container">
                        <div id="mc-company-logo-container" className="mc-company-logo-container">
                            <img id="mc-company-logo" className="mc-company-logo" src={Globals.IMG.CAROUSAL_LOGO} alt="logo" />
                        </div>
                        <div id="reset-account-title-container" className="reset-account-title-container">
                            <div className="reset-account-title-div" id="reset-account-title-div">
                                <h3 className="reset-account-title" id="reset-account-title">{Globals.RESET_ACCOUNT_PASSWORD.PAGE_TITLE}</h3>
                            </div>
                        </div>

                        <div id="reset-account-user-details" className="reset-account-user-details">
                            <div id="test" className="test">
                                <div id="reset-account-password-details " className="reset-account-password-details reset-password">
                                    <label id="email-label" className="reset-email-label">{Globals.RESET_ACCOUNT_PASSWORD.EMAIL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                    <input id="email-inp" className="reset-email-inp" name="email"
                                        value={email}
                                        placeholder={Globals.LOGIN.EMAIL_PLACEHOLDER}
                                        required disabled></input>
                                </div>
                                <div id="reset-account-password-details " className="reset-account-password-details reset-password">
                                    <label id="password-field-title" className="password-field-title">{Globals.RESET_ACCOUNT_PASSWORD.PASSWORD}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                    <div className="reset-account-password-label password_container" onBlur={() => checkForPassword('password')}>
                                        <span className={`password-inp-container ${(isPasswordInValid || isPasswordEmpty || isPasswordFieldMisMatch) ? 'error-field' : ''} ${(password.length > 0 && !isPasswordEmpty && !isPasswordInValid) ? 'valued-field' : ''}`}><input type="password" id="password-inp" className="password-inp password-text" name="password" placeholder={Globals.LOGIN.PASSWORD_PLACEHOLDER} onChange={handlePassword} required></input><img className="view-hide-password" src={!isPasswordVisible ? Globals.IMG.HIDE_PASSWORD : Globals.IMG.VIEW_PASSWORD} alt="view-hide" onClick={() => tooglePasswordView('password-inp', "password")} /></span>
                                    </div>
                                    {(isPasswordInValid || isPasswordEmpty || isPasswordFieldMisMatch) && <><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{((isPasswordFieldMisMatch && Globals.ERROR_MESSAGES.RESET_PAGE_PASSWORD_MISMATCH)) || (isPasswordNotMatched && Globals.ERROR_MESSAGES.RESET_PAGE_PASSWORD_MISMATCH) || (isPasswordEmpty ? Globals.ERROR_MESSAGES.RESET_PASSWORD_EMPTY : Globals.ERROR_MESSAGES.RESET_PAGE_PASSWORD_ERROR)}</label></>}
                                </div>
                                <div id="reset-account-re-enter-password-details" className="reset-account-re-enter-password-details reset-password">
                                    <label id="password-field-title" className="password-field-title">{Globals.RESET_ACCOUNT_PASSWORD.RE_TRY_PASSWORD}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                    <div className="reset-account-re-enter-password-label password_container" onBlur={() => checkForPassword('re-enter')}>
                                        <span className={`password-inp-container ${(isReEnteredPasswordInValid || isReEnteredPasswordEmpty || isPasswordNotMatched) ? 'error-field' : ''} ${reEnteredPassword.length > 0 && !isReEnteredPasswordEmpty && !isReEnteredPasswordEmpty && !isPasswordNotMatched ? 'valued-field' : ''}`}><input type="password" id="re-password-inp" className="password-inp re-password-inp password-text" name="password" placeholder={Globals.LOGIN.PASSWORD_PLACEHOLDER} onChange={handleReEneteredPassword} required></input><img className="view-hide-password" src={!isReEnteredPasswordVisible ? Globals.IMG.HIDE_PASSWORD : Globals.IMG.VIEW_PASSWORD} alt="view-hide" onClick={() => tooglePasswordView('re-password-inp', "re-enter")} /></span>
                                    </div>
                                    {(isReEnteredPasswordInValid || isReEnteredPasswordEmpty || isPasswordNotMatched) && <><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{(isPasswordNotMatched && Globals.ERROR_MESSAGES.RESET_PAGE_PASSWORD_MISMATCH) || (isReEnteredPasswordEmpty ? Globals.ERROR_MESSAGES.RESET_RE_ENTER_PASSWORD_EMPTY : Globals.ERROR_MESSAGES.RESET_PAGE_PASSWORD_ERROR)}</label></>}
                                </div>
                            </div>
                            <div id="reset-account-password-criteria-details" className="reset-account-password-criteria-details">
                                <div className="reset-account-password-criteria">
                                    <div id="reset-account-password-criteria-title" className="reset-account-password-criteria-title password-criteris-txt-color">
                                        <img src={Globals.IMG.PASSWORD_CRITERIA} alt="password criteria password-criteria-txt-color" />
                                        <p className="reset-content-text-label password-criteria-txt-color">{Globals.RESET_ACCOUNT_PASSWORD.PASSWORD_CRITERIA.TITLE}</p>
                                    </div>
                                    <div className="reset-content-text-styles password-criteria-txt-color">
                                        <li>{Globals.RESET_ACCOUNT_PASSWORD.PASSWORD_CRITERIA.CHARS_RANGE}</li>
                                        <li>{Globals.RESET_ACCOUNT_PASSWORD.PASSWORD_CRITERIA.ATLEAST_1_UC}</li>
                                        <li>{Globals.RESET_ACCOUNT_PASSWORD.PASSWORD_CRITERIA.ATLEAST_1_NUM}</li>
                                        <li>{Globals.RESET_ACCOUNT_PASSWORD.PASSWORD_CRITERIA.ATLEAST_1_SPECIAL_CHAR}</li>
                                        <li>{Globals.RESET_ACCOUNT_PASSWORD.PASSWORD_CRITERIA.NO_SPACE}</li>
                                    </div>
                                </div>
                            </div>
                            <div className="reset-account-button" id="reset-account-button">
                                {(password.length > 0 && reEnteredPassword.length > 0 && !isPasswordFieldMisMatch && !isPasswordNotMatched && !isPasswordEmpty && !isPasswordInValid && !isReEnteredPasswordEmpty && !isReEnteredPasswordInValid) ? <Button title={Globals.RESET_ACCOUNT_PASSWORD.BUTTON_TITLE} action={submitDetails} additionalStyle={"activate-account-btn"} /> :
                                    <Button title={Globals.RESET_ACCOUNT_PASSWORD.BUTTON_TITLE} additionalStyle={"disabled-activate-account-btn"} />}
                            </div>
                        </div>
                    </div>
                </div>
                { }
            </div>
            <div id="reset-page-footer" className="reset-page-footer">
                <Footer />
            </div>
            <div>
                {isResetSuccess && <div className='popup-bg'><PopUp title={Globals.RESET_ACCOUNT_PASSWORD.POPUP_MESSAGE.SUCCESS.TITLE}
                    text={Globals.RESET_ACCOUNT_PASSWORD.POPUP_MESSAGE.SUCCESS.MESSAGE}
                    normalAction={navigateToLogin}
                    normalActionText={Globals.RESET_ACCOUNT_PASSWORD.POPUP_MESSAGE.SUCCESS.BUTTON_TEXT}
                    popupType={"activate-success"}
                    onClose={() => setIsResetSuccess(false)}
                /></div>}
                {isResetFailure && <div className='popup-bg'><PopUp title={Globals.RESET_ACCOUNT_PASSWORD.POPUP_MESSAGE.FAILURE.TITLE}
                    text={Globals.RESET_ACCOUNT_PASSWORD.POPUP_MESSAGE.FAILURE.MESSAGE}
                    normalAction={submitDetails}
                    normalActionText={Globals.RESET_ACCOUNT_PASSWORD.POPUP_MESSAGE.FAILURE.BUTTON_TEXT}
                    popupType={"activate-failure"}
                    onClose={() => setIsResetFailure(false)}
                /></div>}
            </div>
        </>
    );
}
export default ForgotPassword;